module.exports = __webpack_public_path__ + "img/effect-chain.7b01eb6d.svg";